import subscribeProperties from '@/common/utils/watchProps'
// const BG_AUDIO = wx.getBackgroundAudioManager()

let time_task = 0
export const AUDIO_STATUS = {
    PLAYING: '1',
    STOP: '2',
    ENDED: '3'
}
export const AUDIO_STORE = subscribeProperties({}, [
    {
        key: 'status',
        defaultValue: AUDIO_STATUS.ENDED
    },
    {
        key: 'duration',
        defaultValue: 0
    },
    {
        key: 'running_time',
        defaultValue: 0
    }
])
const initAudio = () => {
    // BG_AUDIO.onPlay(() => {
    //     AUDIO_STORE.status = AUDIO_STATUS.PLAYING
    // })
    // BG_AUDIO.onEnded(() => {
    //     AUDIO_STORE.status = AUDIO_STATUS.ENDED
    // })
    // BG_AUDIO.onStop(() => {
    //     AUDIO_STORE.status = AUDIO_STATUS.STOP
    // })
}

const playAudio = (audio_url, _title, running_time = 0) => {
    // BG_AUDIO.stop()
    // setTimeout(() => {
    //     AUDIO_STORE.running_time = running_time
    //     BG_AUDIO.src = audio_url + '?v=' + encodeURI(_title)
    //     BG_AUDIO.startTime = running_time
    //     BG_AUDIO.play()
    //     BG_AUDIO.title = (_title || '') + '户型图介绍'
    //     BG_AUDIO.onCanplay(() => {
    //         setTimeout(() => {
    //             AUDIO_STORE.duration = BG_AUDIO.duration
    //         }, 100)
    //     })
    // })
}
const stopAudio = () => {
    // BG_AUDIO.stop()
}
const seekAudio = (percent) => {
    // const seeking_time = AUDIO_STORE.duration * percent
    // BG_AUDIO.seek(seeking_time)
    // AUDIO_STORE.running_time = seeking_time
    // return seeking_time
}
const runClock =() => {
    // stopRunningTime()
    // time_task = setInterval(() => {
    //     const running_time = AUDIO_STORE.running_time
    //     if (running_time < parseInt(AUDIO_STORE.duration)) {
    //         AUDIO_STORE.running_time++
    //     } else {
    //         stopRunningTime()
    //     }
    // }, 1000)
}
const stopRunningTime = () => {
    // time_task && clearInterval(time_task)
}
const resetRunningTime =() => {
    // AUDIO_STORE.running_time = 0
}
const AUDIO = {
    initAudio,
    playAudio,
    stopAudio,
    seekAudio,
    runClock,
    stopRunningTime,
    resetRunningTime
}

export default AUDIO